import {createAsyncAction} from '../services/redux-toolkit'

export const getStaticMapUrl = createAsyncAction<string, string>(
  'GET_STATIC_MAP_URL',
  async (language, {getState, extra: {serverApi}}) => {
    const event = getState().event
    return serverApi.getStaticMapUrl(event.id, language)
  },
)
